import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import JobRoleSelect from "@/components/widgets/input/JobRoleSelect.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  ScopeService,
  ScopeServiceQuery,
  CreateScopeServiceTeamRoleMutation,
  CreateScopeServiceTeamRoleMutationMutation,
  CreateScopeServiceTeamRoleMutationMutationVariables,
  UpdateScopeServiceTeamRoleMutation,
  UpdateScopeServiceTeamRoleMutationMutation,
  UpdateScopeServiceTeamRoleMutationMutationVariables,
  DeleteScopeServiceTeamRoleMutation,
  DeleteScopeServiceTeamRoleMutationMutation,
  DeleteScopeServiceTeamRoleMutationMutationVariables,
} from "@/gql"

type RoleItem = {
  roleId: number | null
  quantity: number | null
  scopeServiceTeamRoleId?: string
}
type Form = {
  teamRolesAttributes: RoleItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeServiceTeamRoleForm',
  props: {
    service: null
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }) {

const props = __props as { service: ScopeService }




const refetchQueries = computed(() => {
  return [
    {
      query: ScopeServiceQuery,
      variables: {
        id: props.service.id,
      },
    },
  ]
})

const defaultRole = {
  roleId: null,
  quantity: null,
  scopeServiceTeamRoleId: "",
}

const defaultForm = {
  teamRolesAttributes: [
    {
      ...defaultRole,
    },
  ],
}

const form = ref<Form>({
  ...defaultForm,
})

const onAddNewRole = () => {
  form.value.teamRolesAttributes.push({
    ...defaultRole,
  })
}

const removeRole = (role: RoleItem) => {
  form.value.teamRolesAttributes = form.value.teamRolesAttributes.filter(
    (rle) => rle.roleId !== role.roleId
  )
}

const onRemoveRole = (role: RoleItem) => {
  if (form.value.teamRolesAttributes.length === 1) return

  if (role.scopeServiceTeamRoleId) {
    deleteRole(role)
  } else {
    removeRole(role)
  }
}

const observer = ref(null)

const isSubmitting = ref(false)
const isDeleting = ref(false)
const { mutate } = useMutation()
const { addSuccess } = useNotification()

const onReset = () => {
  form.value = { ...defaultForm }

  return (observer.value as any)?.reset()
}

const onRoleChange = async (role: RoleItem) => {
  if (!(role.quantity && role.roleId)) return

  if (role.scopeServiceTeamRoleId) await updateTier(role)
  else await createTier(role)
}

const createTier = async (role: RoleItem) => {
  isSubmitting.value = true

  const result = await mutate<
    CreateScopeServiceTeamRoleMutationMutation,
    CreateScopeServiceTeamRoleMutationMutationVariables
  >({
    mutation: CreateScopeServiceTeamRoleMutation,
    variables: {
      scopeServiceId: props.service.id,
      scopeServiceTeamRoleInput: {
        roleId: role.roleId,
        quantity: role.quantity || 1,
      },
    },
    handlePayloadErrors: true,
    refetchQueries: refetchQueries.value,
  })

  isSubmitting.value = false

  if (result?.data?.createScopeServiceTeamRole.scopeServiceTeamRole?.id) {
    addSuccess("Role created successfully")
    role.scopeServiceTeamRoleId = result.data.createScopeServiceTeamRole.scopeServiceTeamRole.id
    return
  }
}

const updateTier = async (role: RoleItem) => {
  if (!role.scopeServiceTeamRoleId) return
  isSubmitting.value = true
  const result = await mutate<
    UpdateScopeServiceTeamRoleMutationMutation,
    UpdateScopeServiceTeamRoleMutationMutationVariables
  >({
    mutation: UpdateScopeServiceTeamRoleMutation,
    variables: {
      scopeServiceTeamRoleId: role.scopeServiceTeamRoleId,
      scopeServiceTeamRoleInput: {
        roleId: role.roleId,
        quantity: role.quantity || 1,
      },
    },
    handlePayloadErrors: true,
  })
  if (result?.data?.updateScopeServiceTeamRole.scopeServiceTeamRole?.id) {
    addSuccess("Role updated successfully")
  }
  isSubmitting.value = false
}

const deleteRole = async (role: RoleItem) => {
  if (!role.scopeServiceTeamRoleId) return

  isDeleting.value = true
  const result = await mutate<
    DeleteScopeServiceTeamRoleMutationMutation,
    DeleteScopeServiceTeamRoleMutationMutationVariables
  >({
    mutation: DeleteScopeServiceTeamRoleMutation,
    variables: {
      scopeServiceTeamRoleId: role.scopeServiceTeamRoleId,
    },
    handlePayloadErrors: true,
    refetchQueries: refetchQueries.value,
  })
  if (!result?.data?.deleteScopeServiceTeamRole.error) {
    addSuccess("Role deleted successfully")
    removeRole(role)
  }
  isDeleting.value = false
}

watch(
  () => props.service.teamRoles,
  (teamRoles) => {
    console.log({ teamRoles })
    if (teamRoles.length) {
      form.value = {
        teamRolesAttributes: teamRoles.map((role) => ({
          roleId: role.role.id,
          quantity: role.quantity,
          scopeServiceTeamRoleId: role.id,
        })),
      }
    }
  },
  { immediate: true, deep: true }
)

const onCancel = () => {
  onReset()
  emit("close")
}

expose({ onReset })

return { __sfc: true,props, emit, refetchQueries, defaultRole, defaultForm, form, onAddNewRole, removeRole, onRemoveRole, observer, isSubmitting, isDeleting, mutate, addSuccess, onReset, onRoleChange, createTier, updateTier, deleteRole, onCancel, Icon, JobRoleSelect }
}

})